import { default as account_45recoveryOM8kPx9CPLMeta } from "/vercel/path0/pages/account-recovery.vue?macro=true";
import { default as areaf1f5Qn11vYMeta } from "/vercel/path0/pages/area.vue?macro=true";
import { default as authI5JGIXywJyMeta } from "/vercel/path0/pages/auth.vue?macro=true";
import { default as fertilizerbdzNqU62i0Meta } from "/vercel/path0/pages/fertilizer.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as measurements_32copyhtZSs68it6Meta } from "/vercel/path0/pages/measurements copy.vue?macro=true";
import { default as measurementsWnUeNebdTAMeta } from "/vercel/path0/pages/measurements.vue?macro=true";
import { default as profilekxSCn5bMpQMeta } from "/vercel/path0/pages/profile.vue?macro=true";
import { default as _91id_93_45_91land_93_45_91vege_93mUkptQYAzMMeta } from "/vercel/path0/pages/Report/[id]-[land]-[vege].vue?macro=true";
import { default as signupY93ILdpGpbMeta } from "/vercel/path0/pages/signup.vue?macro=true";
import { default as vegetables0OcNQZ4JtbMeta } from "/vercel/path0/pages/vegetables.vue?macro=true";
export default [
  {
    name: account_45recoveryOM8kPx9CPLMeta?.name ?? "account-recovery",
    path: account_45recoveryOM8kPx9CPLMeta?.path ?? "/account-recovery",
    meta: account_45recoveryOM8kPx9CPLMeta || {},
    alias: account_45recoveryOM8kPx9CPLMeta?.alias || [],
    redirect: account_45recoveryOM8kPx9CPLMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/account-recovery.vue").then(m => m.default || m)
  },
  {
    name: areaf1f5Qn11vYMeta?.name ?? "area",
    path: areaf1f5Qn11vYMeta?.path ?? "/area",
    meta: areaf1f5Qn11vYMeta || {},
    alias: areaf1f5Qn11vYMeta?.alias || [],
    redirect: areaf1f5Qn11vYMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/area.vue").then(m => m.default || m)
  },
  {
    name: authI5JGIXywJyMeta?.name ?? "auth",
    path: authI5JGIXywJyMeta?.path ?? "/auth",
    meta: authI5JGIXywJyMeta || {},
    alias: authI5JGIXywJyMeta?.alias || [],
    redirect: authI5JGIXywJyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth.vue").then(m => m.default || m)
  },
  {
    name: fertilizerbdzNqU62i0Meta?.name ?? "fertilizer",
    path: fertilizerbdzNqU62i0Meta?.path ?? "/fertilizer",
    meta: fertilizerbdzNqU62i0Meta || {},
    alias: fertilizerbdzNqU62i0Meta?.alias || [],
    redirect: fertilizerbdzNqU62i0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/fertilizer.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: logint0AWlhQgM0Meta?.name ?? "login",
    path: logint0AWlhQgM0Meta?.path ?? "/login",
    meta: logint0AWlhQgM0Meta || {},
    alias: logint0AWlhQgM0Meta?.alias || [],
    redirect: logint0AWlhQgM0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login.vue").then(m => m.default || m)
  },
  {
    name: measurements_32copyhtZSs68it6Meta?.name ?? "measurements copy",
    path: measurements_32copyhtZSs68it6Meta?.path ?? "/measurements%20copy",
    meta: measurements_32copyhtZSs68it6Meta || {},
    alias: measurements_32copyhtZSs68it6Meta?.alias || [],
    redirect: measurements_32copyhtZSs68it6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/measurements copy.vue").then(m => m.default || m)
  },
  {
    name: measurementsWnUeNebdTAMeta?.name ?? "measurements",
    path: measurementsWnUeNebdTAMeta?.path ?? "/measurements",
    meta: measurementsWnUeNebdTAMeta || {},
    alias: measurementsWnUeNebdTAMeta?.alias || [],
    redirect: measurementsWnUeNebdTAMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/measurements.vue").then(m => m.default || m)
  },
  {
    name: profilekxSCn5bMpQMeta?.name ?? "profile",
    path: profilekxSCn5bMpQMeta?.path ?? "/profile",
    meta: profilekxSCn5bMpQMeta || {},
    alias: profilekxSCn5bMpQMeta?.alias || [],
    redirect: profilekxSCn5bMpQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_45_91land_93_45_91vege_93mUkptQYAzMMeta?.name ?? "Report-id-land-vege",
    path: _91id_93_45_91land_93_45_91vege_93mUkptQYAzMMeta?.path ?? "/Report/:id()-:land()-:vege()",
    meta: _91id_93_45_91land_93_45_91vege_93mUkptQYAzMMeta || {},
    alias: _91id_93_45_91land_93_45_91vege_93mUkptQYAzMMeta?.alias || [],
    redirect: _91id_93_45_91land_93_45_91vege_93mUkptQYAzMMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/Report/[id]-[land]-[vege].vue").then(m => m.default || m)
  },
  {
    name: signupY93ILdpGpbMeta?.name ?? "signup",
    path: signupY93ILdpGpbMeta?.path ?? "/signup",
    meta: signupY93ILdpGpbMeta || {},
    alias: signupY93ILdpGpbMeta?.alias || [],
    redirect: signupY93ILdpGpbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: vegetables0OcNQZ4JtbMeta?.name ?? "vegetables",
    path: vegetables0OcNQZ4JtbMeta?.path ?? "/vegetables",
    meta: vegetables0OcNQZ4JtbMeta || {},
    alias: vegetables0OcNQZ4JtbMeta?.alias || [],
    redirect: vegetables0OcNQZ4JtbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/vegetables.vue").then(m => m.default || m)
  }
]